import {
    OBSERVACIO_EXPORTACIO_INICIALITZAR,
    OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS
} from '../../../actions/actionTypes.js';

const ESTAT_INICIAL = {};

const tots = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case OBSERVACIO_EXPORTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS:
            return action.observacions;

        default:
            return state;
    }
};

export default tots;



// WEBPACK FOOTER //
// ./src/reducers/observacio/exportacio/tots.js